import React, { Component } from 'react';
import { Outlet } from 'react-router-dom';
// main layout imports
import { Layout } from 'antd';

const { Content } = Layout;

class Empty extends Component {
	render() {
		return (
			<Layout className="emptyLayout">
				<Content className="content">
					<Outlet />
				</Content>
			</Layout>
		);
	}
}

Empty.propTypes = {};

export default Empty;
